import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; 2026 RCF Pratibha Poshak. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
